const steps = {
    SIMPLE_DATA_TYPE_SELECTION: 'SIMPLE_DATA_TYPE_SELECTION',
    DETAILED_DATA_TYPE_SELECTION: 'DETAILED_DATA_TYPE_SELECTION',
    SUCCESS: 'SUCCESS',
};

export default steps;
